import type { ComponentChildren } from 'preact';
import { route } from 'preact-router';
import { isAdmin, isSuperadmin } from '../store/state';
import { logout } from '../store/actions/auth.actions';
import { useAdminDesktopClass } from '../hooks/useAdminDesktopClass';
import { Icon } from '../components/Icon';

interface ShellProps {
  tab: 'dashboard' | 'clientes' | 'agenda' | 'perfil' | 'plataforma' | '';
  children: ComponentChildren;
}

export function Shell({ tab, children }: ShellProps) {
  useAdminDesktopClass();

  return (
    <>
      <header class="topbar">
        <h1>
          <Icon name="wrench" size={18} />
          Visitas Técnicas
        </h1>
        <div class="topbar-actions">
          <button
            class={'link' + (tab === 'perfil' ? ' active' : '')}
            onClick={() => route('/perfil')}
          >
            <Icon name="settings" size={16} />
            Perfil
          </button>
          <button class="link" onClick={() => logout()}>
            <Icon name="log-out" size={16} />
            Salir
          </button>
        </div>
      </header>
      <main>
        <div key={typeof window !== 'undefined' ? window.location.pathname : tab} class="view-enter">
          {children}
        </div>
      </main>
      <nav class="tabbar">
        {isSuperadmin.value ? (
          <button class={tab === 'plataforma' ? 'active' : ''} onClick={() => route('/plataforma')}>
            <Icon name="building-2" size={20} />
            Plataforma
          </button>
        ) : (
          <>
            {isAdmin.value && (
              <button
                class={tab === 'dashboard' ? 'active' : ''}
                onClick={() => route('/dashboard')}
              >
                <Icon name="layout-dashboard" size={20} />
                Dashboard
              </button>
            )}
            {isAdmin.value && (
              <button class={tab === 'clientes' ? 'active' : ''} onClick={() => route('/clientes')}>
                <Icon name="users" size={20} />
                Clientes
              </button>
            )}
            <button class={tab === 'agenda' ? 'active' : ''} onClick={() => route('/agenda')}>
              <Icon name="calendar-days" size={20} />
              Agenda
            </button>
          </>
        )}
      </nav>
    </>
  );
}
